module.exports = __webpack_public_path__ + "img/xuanchuan01.6ddb5aa4.png";